import { DropdownProps, Dropdown as FluentUIDropdown } from "@fluentui/react-northstar";
import { useState } from "react";

type Props = {
  // excluding onClick because it's not being used.
  onClick?: undefined;
  // When a dropdown opens, it displays a list of items.
  // We need to figure out a way to check if an item in the list is selected.
  // This function decide if an item is selected
  // It is called for each item in the items list, if the function returns true, the item is marked as selected.
  // This is only for visual purpose. It doesn't affect the value selection of a dropdown which is handled by fluentUI.
  isItemSelected: (item: any) => boolean;
} & DropdownProps;

/**
 * This is a wrapper around FluentUI's dropdown to fix the default selected value.
 * Don't update it's props.
 * @param props must always have at-least the same props required by FluentUI Dropdown
 * @returns
 */
export const Dropdown: React.FC<Props> = props => {
  const { items, isItemSelected, ...dropdownProps } = props;

  const [isHovered, setIsHovered] = useState<boolean>();

  return (
    <FluentUIDropdown
      {...dropdownProps}
      onClick={() => {
        setIsHovered(false);
      }}
      items={(items || []).map(item => {
        if (item === null || typeof item !== "object") {
          return item;
        }

        const isSelected = isItemSelected(item);

        return {
          ...item,
          selected: isSelected,
          ...(!isHovered && {
            active: isSelected,
          }),
          onMouseEnter: () => {
            setIsHovered(true);
          },
        };
      })}
    />
  );
};
